import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import posthog from "./lib/posthog";
import "./index.css";
import App from "./App";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

// Load Stripe.js
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
if (stripePublishableKey) {
  const script = document.createElement("script");
  script.src = "https://js.stripe.com/v3/";
  script.async = true;
  document.head.appendChild(script);
  
  script.onload = () => {
    if ((window as any).Stripe) {
      (window as any).Stripe = (window as any).Stripe(stripePublishableKey);
    }
  };
  script.onerror = () => {
    console.error("Stripe.js failed to load (network issue or ad blocker) — checkout will be unavailable.");
  };
} else {
  console.warn("VITE_STRIPE_PUBLISHABLE_KEY is not set — Stripe.js not loaded, checkout will be unavailable.");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>
);
